<template>
    <div>
        <button
            type="submit"
            class="dark:hover:bg-gray-800 soli-round block w-full px-4 py-2 text-sm leading-5 text-gray-700 text-left hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
            v-if="as == 'button'"
        >
            <slot></slot>
        </button>

        <Link
            :href="href"
            class="dark:hover:bg-gray-800 soli-round block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out"
            v-else
        >
            <slot></slot>
        </Link>
    </div>
</template>

<script>
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        Link,
    },
    props: ["href", "as"],
};
</script>
